import request from '@/utils/request'

/**
 * 获取户主列表数据
 */
export const getHouseholdLists = (data) => {
    return request({
        url: '/household/lists',
        params: data
    })
}

/**
 * 户主-详情
 */
export const getHouseholdDetail = (id) => {
    return request({
        url: `/household/${id}`
    })
}

/**
 * 户主-修改
 */
export const putHousehold = (data) => {
    return request({
        url: '/household/manage',
        method: 'PUT',
        data
    })
}

/**
 * 户主-添加
 */
export const addHousehold = (data) => {
    return request({
        url: '/household/manage',
        method: 'POST',
        data
    })
}

/**
 * 户主-删除
 */
export const delHousehold = (id) => {
    return request({
        url: `/household/${id}`,
        method: 'DELETE'
    })
}
/**
 * 户主-绑定房间
 */
export const bindRooms = (data) => {
    return request({
        url: '/household/bind_room',
        method: 'POST',
        data
    })
}
/**
 * 获取账户日志列表数据
 */
export const getAccountLogLists = (data) => {
    return request({
        url: '/account_log/lists',
        params: data
    })
}
